export interface WalletBalanceInput {
	amount?: string | number | null;
	creditLimit?: string | number | null;
	frozenMoney?: string | number | null;
}

export interface WalletBalanceView {
	/** What the buyer can still order for: own funds + credit − reserved. */
	available: number;
	/** Part of the credit limit already consumed (wallet amount below 0). */
	usedCredit: number;
	creditLimit: number;
}

const toNumber = (value?: string | number | null): number => {
	const number = typeof value === 'number' ? value : parseFloat(value ?? '');
	return Number.isFinite(number) ? number : 0;
};

const round2 = (value: number) => Math.round(value * 100) / 100;

/**
 * Orders covered by the credit limit are withdrawn from the wallet, so its raw
 * `amount` goes below zero while nothing is overdue. Showing that number as the
 * "balance" reads as debt; the buyer sees what is available and how much of
 * the credit is in use instead.
 */
export const getWalletBalanceView = (
	wallet?: WalletBalanceInput | null,
): WalletBalanceView => {
	const amount = toNumber(wallet?.amount);
	const creditLimit = toNumber(wallet?.creditLimit);
	const frozen = toNumber(wallet?.frozenMoney);
	return {
		available: round2(amount + creditLimit - frozen),
		usedCredit: round2(Math.max(0, -amount)),
		creditLimit,
	};
};
